
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

const articlesSizes = [
  "size-4-12",
  "size-5-12",
  "size-3-12",
  "size-5-12",
  "size-3-12",
  "size-4-12",
  "size-8-12",
  "size-4-12",
  "size-6-12",
  "size-6-12",
];

export default {
  fetch: async function () {
    await this.initState();
    await this.getTags();
    await this.getArticles(1);
  },

  head: function () {
    const setHead = this.setHead;
    const title = setHead?.title || "";
    const description = setHead?.description || "";

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },

  data: function () {
    return {
      articles: [],
      tags: [],

      pagination: {
        page: 1,
        totalPage: 1
      },
      activeTag: "",

      isLoad: true
    }
  },

  components: {
    Breadcrumbs,

    ArticleCardNew: () => import("~/components/articles/ArticleCardNew.vue"),
    Pagination: () => import("~/components/UI/Pagination.vue")
  },

  computed: {
    breadcrumbs: function () {
      return [
        { title: "Главная", path: "/" },
        { title: "Статьи", path: this.$route.fullPath },
      ]
    },

    setHead: function () {
      const article = this.articles?.[0] || {};
      const articleSeo = article?.category || {};

      return {
        title: articleSeo?.seo_title,
        description: articleSeo?.seo_description,
      }
    }
  },

  methods: {
    initState: function () {
      const query = this.$route.query;
      this.pagination.page = query?.page || 1;
      this.activeTag = Boolean(query?.tag) ? Number.parseFloat(query?.tag) : "";
    },

    getTags: async function () {
      const res = await this.$api.agent.transport.get('/articles/tags?filter[has_articles]=1&filter[has_category_id]=2').then((res) => {
        return res.data
      }).catch(() => {
        return []
      });
      this.tags = res;
    },
    getArticles: async function (newPage) {
      this.isLoad = true;

      const page = newPage || this.$route.query?.page || this.pagination.page;
      let search = [
        `page=${page}`,
        'filter[category_slug]=articles',
        'expand=tags,category'
      ];
      if (this.activeTag) {
        search.push(`filter[tag_id]=${this.activeTag}`);
      }
      const response = await this.$api.agent.transport.get(`/articles?${ search.join('&') }`).then((res) => {
        return res
      }).catch(() => {
        return {}
      });

      const pagination = {
        page: Number.parseFloat(response?.headers?.['x-pagination-current-page'] || 1),
        totalPage: Number.parseFloat(response?.headers?.['x-pagination-page-count'] || 1)
      };
      const articles = response?.data || [];
      this.setSearchParams(pagination.page);

      this.articles = articles;
      this.pagination = pagination;
      this.isLoad = false;
    },
    changePage: async function (newPage) {
      let pagination = {...this.pagination}
      pagination.page = newPage;
      this.pagination = pagination;

      const listPosition = this.$refs.refList.getBoundingClientRect()?.top + document.body.scrollTop;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      await this.getArticles(newPage);
    },
    changeTag: async function (tag) {
      this.activeTag = tag;

      let pagination = {...this.pagination}
      pagination.page = 1;
      this.pagination = pagination;

      const listPosition = this.$refs.refList.getBoundingClientRect()?.top + document.body.scrollTop;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      await this.getArticles(1);
    },
    setSearchParams: function (page) {
      if (!process.client) {
        return
      }

      let search = [
        `page=${page}`
      ];
      if (this.activeTag) {
        search.push(`tag=${this.activeTag}`)
      }

      window.history.replaceState(null, null, `${window.location?.pathname}?${search.join("&")}`)
    },

    _getClassesArticles: function (_index) {
      let index = _index;
      if (index >= articlesSizes.length) {
        index = index - articlesSizes.length;
      }

      return articlesSizes[index]
    },
  }
}
